<div style="font-size: 21px; font-weight: 600; margin: 20px; color: #333">
  {{ chartTitle }}
</div>
<div id="my-superset-dashboard"></div>
